import { Component, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TARIFF_TEXT_KEYS } from '../../../enums/tariffTextKeys';
import { TariffTextItem } from '../../../../../assets/js/com/ts_api_client';
import { getInfoIText } from '../../../services/tariff-advisor.service';

@Component({
    selector: 'bdo-charge-flex-bonus',
    templateUrl: './charge-flex-bonus.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChargeFlexBonusComponent implements OnInit {
  public bonusValue = input.required<number>();
  public infois = input<Array<TariffTextItem>>();
  public bonusInfo: string = '';

  ngOnInit() {
    this.bonusInfo = getInfoIText(this.infois(), TARIFF_TEXT_KEYS.chargeFlexBonus_tileText);
  };
}
